/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Ats_Score_Credit_HintInputs */

const en_onboarding_ats_score_credit_hint = /** @type {(inputs: Onboarding_Ats_Score_Credit_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 AI action`)
};

const de_onboarding_ats_score_credit_hint = /** @type {(inputs: Onboarding_Ats_Score_Credit_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 KI-Aktion`)
};

const fr_onboarding_ats_score_credit_hint = /** @type {(inputs: Onboarding_Ats_Score_Credit_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 action IA`)
};

const es_onboarding_ats_score_credit_hint = /** @type {(inputs: Onboarding_Ats_Score_Credit_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 acción IA`)
};

const it_onboarding_ats_score_credit_hint = /** @type {(inputs: Onboarding_Ats_Score_Credit_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 azione IA`)
};

const nl_onboarding_ats_score_credit_hint = /** @type {(inputs: Onboarding_Ats_Score_Credit_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 AI-actie`)
};

const pl_onboarding_ats_score_credit_hint = /** @type {(inputs: Onboarding_Ats_Score_Credit_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 akcja AI`)
};

const fi_onboarding_ats_score_credit_hint = /** @type {(inputs: Onboarding_Ats_Score_Credit_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 AI-toiminto`)
};

const da_onboarding_ats_score_credit_hint = /** @type {(inputs: Onboarding_Ats_Score_Credit_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 AI-handling`)
};

const sv_onboarding_ats_score_credit_hint = /** @type {(inputs: Onboarding_Ats_Score_Credit_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 AI-åtgärd`)
};

/**
* | output |
* | --- |
* | "1 AI action" |
*
* @param {Onboarding_Ats_Score_Credit_HintInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const onboarding_ats_score_credit_hint = /** @type {((inputs?: Onboarding_Ats_Score_Credit_HintInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Ats_Score_Credit_HintInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_onboarding_ats_score_credit_hint(inputs)
	if (locale === "fr") return fr_onboarding_ats_score_credit_hint(inputs)
	if (locale === "es") return es_onboarding_ats_score_credit_hint(inputs)
	if (locale === "it") return it_onboarding_ats_score_credit_hint(inputs)
	if (locale === "nl") return nl_onboarding_ats_score_credit_hint(inputs)
	if (locale === "pl") return pl_onboarding_ats_score_credit_hint(inputs)
	if (locale === "fi") return fi_onboarding_ats_score_credit_hint(inputs)
	if (locale === "da") return da_onboarding_ats_score_credit_hint(inputs)
	if (locale === "sv") return sv_onboarding_ats_score_credit_hint(inputs)
	return en_onboarding_ats_score_credit_hint(inputs)
});